import { useAuth } from "@/contexts/AuthContext";

export function DemoBadge({ className = "" }) {
  const { user } = useAuth();
  if (!user?.is_demo) return null;
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] uppercase tracking-[0.15em] font-bold bg-amber-100 text-amber-800 border border-amber-200 ${className}`}
      title="You are signed in with a demo account. Replace demo passwords before real production use."
    >
      Demo Data
    </span>
  );
}
